$(document).ready(function() {
  $(".review_slider").slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    autoplay: false,
    speed: 900,
    autoplaySpeed: 700,
    adaptiveHeight: true,
    prevArrow: '<div class="slick_arrow prev_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12L5 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19L5 12L12 5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="slick_arrow next_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99988 12H18.9999" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9999 5L18.9999 12L11.9999 19" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  $(".tabimg_slider").slick({
    arrows: true,
    dots: false,
    slidesToShow: 1,
    autoplay: false,
    speed: 900,
    autoplaySpeed: 700,
    adaptiveHeight: true,
    prevArrow: '<div class="slick_arrow prev_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12L5 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19L5 12L12 5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="slick_arrow next_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99988 12H18.9999" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9999 5L18.9999 12L11.9999 19" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
  });

   $('.list_name:nth-child(1)').addClass("active");
   $('.list_content:nth-child(1)').addClass("itg_show");
    $('.list_name').on("click", function(){
      $(this).each(function(){
      var show = $(this).attr("id");
      //alert(show);
      $('.list_name').removeClass("active");   
      $(this).addClass("active");
      $(this).parent().siblings('.tab_page-width').find('.tab_content').find('.list_content').each(function(){ 
      var call = $(this).attr('data-item');
         //alert(call);
         if(show == call){
           $('.list_content').removeClass("itg_show");
           $(this).addClass("itg_show");
         }
       });
      });
    }); 

  $(".product__accordion").find(".accordion__title").on('click', function(e) {
     e.preventDefault();
     var get_title = $(this).attr('data-title');
     //alert(get_title);
     $('.list_name').removeClass("active");
    $('.list_content').removeClass("itg_show");
    $('.list_name[data-get="'+get_title+'"]').addClass("active");
    $('.list_content[data-get="'+get_title+'"]').addClass("itg_show");

     $([document.documentElement, document.body]).animate({
        scrollTop: $(".tab_main").offset().top
    }, 2000);
 
  });

$('.main_product').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  asNavFor: '.thumb_product',
});
$('.thumb_product').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.main_product',
  vertical: true,
  centerMode: true,
  verticalSwiping: true,
  focusOnSelect: true,
  infinite: true,
  arrows:true,
  prevArrow:'<div class="slick-arrow slick-prev"><svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5898 6L6.58984 1L1.58984 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:'<div class="slick-arrow slick-next"><svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.58984 1L6.58984 6L11.5898 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  responsive: [
   {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
//   $('.slider-main').slick({
//     slidesToShow: 1,
//     lazyLoad: 'ondemand',
//     slidesToScroll: 1,
//     fade: true,
//     asNavFor: '.slider-thumb',
//     arrows: false,
//     adaptiveHeight: true,
//   });
// $('.slider-thumb').slick({
//     slidesToShow: 4,
//    //lazyLoad: 'ondemand',
//     centerMode: true,
//     slidesToScroll: 1, 
//     //infinite: true,
//     vertical:true,
//     asNavFor: '.slider-main',
//     dots: false,
//     focusOnSelect: true,
//     verticalSwiping:true,
//     arrows:true,
//     prevArrow:'<div class="slick-arrow slick-prev"><svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5898 6L6.58984 1L1.58984 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
//     nextArrow:'<div class="slick-arrow slick-next"><svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.58984 1L6.58984 6L11.5898 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
//     responsive: [
//     {
//         breakpoint: 992,
//         settings: {
//           vertical: true,
//         }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         vertical: true,
//       }
//     },
//     {
//       breakpoint: 580,
//       settings: {
//         vertical: false,
//         slidesToShow: 3,
//       }
//     },
//     {
//       breakpoint: 380,
//       settings: {
//         vertical: false,
//         slidesToShow: 2,
//       }
//     }
//     ]
// });


 $('.tab_items:nth-child(1)').addClass('tab-active');
   $('.tab_blocks:nth-child(1)').addClass('tab-show');
    $('.tab_items').on('click', function(){
      $(this).each(function(){
      var get = $(this).attr('data-id');
      //alert(get);
      $('.tab_items').removeClass('tab-active');   
      $(this).addClass('tab-active');
      $(this).parent().parent().siblings('.tab_content_block').find('.tab_blocks').each(function(){ 
      var set = $(this).attr('data-list');
         //alert(set);
         if(get === set){
           $('.tab_blocks').removeClass('tab-show');
           $(this).addClass('tab-show');
         }
       });
      });
    });



// $(".ctt_variant_input .product-form__input label").each(function(){
// var varid = $(this).attr('data-varid');
//   //alert(varid);
//   $(".thumb_image").attr('data-thumbsrc' , varid);
//  });
  
// $(".ctt-variant .product-form__input label").on("click", function(){
// var varid = $(this).attr('data-varid');
//   //alert(varid);
//   //$(".thumb_image").attr('data-thumbsrc' , varid);
//  $(".thumb_image").each(function(){
// var thumbid = $(this).attr('data-thumbsrc');
//    //alert(thumbid);
 
//    if (varid == thumbid){
//       $(this).trigger('click');
//    }
//  });
// });
  $(document).on('change', '.product-form__input select.select__select', function() {
  var variantImage = $(this).find(":selected").attr('data-image');
    $(".thumb_product .thumb_image").each(function(){
    var thumbImgsrc = $(this).attr('data-imgsrc');
   if (thumbImgsrc == variantImage){
      $(this).click();
   }
 }); 
});
  $(document).on('click', '.product-form__input input[type=radio]+label', function() {
  var variantImage = $(this).attr('data-image');
    $(".thumb_product .thumb_image").each(function(){
    var thumbImgsrc = $(this).attr('data-imgsrc');
   if (thumbImgsrc == variantImage){
      $(this).click();
   }
 }); 
}); 
});
$(window).on('load', function () { 
  $('.slider-thumb').slick('refresh');
});
//$('.slider-thumb').slick('reinit');


$(window).scroll(function(){
  $(".itg-product-recommend").slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    autoplay: false,
    speed: 900,
    autoplaySpeed: 700,
    adaptiveHeight: true,
    prevArrow: '<div class="slick_arrow prev_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12L5 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19L5 12L12 5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="slick_arrow next_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99988 12H18.9999" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9999 5L18.9999 12L11.9999 19" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  
 });
  
 $(document).ready(function(){ 
   //alert($('.video_url_mp .videoOverly video').attr('muted'));
        //if ($('.video_url_mp .videoOverly video').attr('muted') == 'unmuted'){
        //$(".video_url_mp .videoOverly video").prop('muted', false);
        //}
      $(".veidio_mute_icon_play").click(function() {
        $(this).hide();
        $('.veidio_mute_icon_pause').show();
        if( $(".video_url_mp .videoOverly video").prop('muted', true) ) {
          $(".video_url_mp .videoOverly video").prop('muted', false);
        }
      });
      $(".veidio_mute_icon_pause").click(function() { 
        $(this).hide();
        $('.veidio_mute_icon_play').show();
        if( $(".video_url_mp .videoOverly video").prop('muted', false) )  {
          $(".video_url_mp .videoOverly video").prop('muted', true);
        }
      });
    });


$( document ).ready(function() {
  $('.slider_center').slick({
   centerMode: !0,
  centerPadding: "70px",
 infinite: !0,
  arrows: false,
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "70px",
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
         centerPadding: "70px",
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  $('.qtybox .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  });  
    
});

